import React, {useState} from 'react';

import {assertAndContinue} from 'Asserts';
import preferences from 'Preferences';
import CheckboxInput from 'ui-library/inputs/CheckboxInput';

export interface PreferenceCheckboxProps {
  disabled?: boolean;
  id: string;
  label: string;
  preferenceKey: string;
}

function PreferenceCheckbox(props: PreferenceCheckboxProps): JSX.Element {
  let initialValue = preferences.get(props.preferenceKey);
  if (initialValue != null) {
    assertAndContinue(typeof initialValue === 'boolean', 'Expected boolean value for preference checkbox');
  } else {
    initialValue = false;
  }
  const [preferenceValue, setPreferenceValue] = useState<boolean>(initialValue);

  return (
    <CheckboxInput
      checked={preferenceValue}
      disabled={props.disabled}
      id={props.id}
      label={props.label}
      onChange={(e) => {
        setPreferenceValue(e.target.checked);
        preferences.set(props.preferenceKey, e.target.checked);
      }}
    />
  );
}

export default PreferenceCheckbox;
